// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2Jvxj","title":"AfterBackImages_title__FmFlm","images":"AfterBackImages_images__ald3d"};